import Raven from "raven-js";

function init() {
  Raven.config("https://c659a6242f61475bb50beb0788c53ba2@sentry.io/1368196", {
    release: "1-0-0",
    environment: "development-test"
  }).install();
}
function log(error) {
  Raven.captureException(error);
}

export default {
  init,
  log
};



// WEBPACK FOOTER //
// ./src/services/logService.js